import React from 'react';

import styles from './ZtShowApps.module.less';
import Header from '../Header';
import GameLink from '../GameLink';
import Icon from '../Icon';
import Button from '../Button';

export default ({ title, operate, to, tag: source, data = {} }) => {
  data.apps = data.apps || [];

  return (
    <div className={styles.ZtShowApps}>
      <Header title={title} operate={operate === '2' ? '2' : '0'} to={to} source={source} />
      <section>
        <GameLink
          style={{ backgroundImage: `url("${data.contentImgBig || data.contentImg}")` }}
          info={data}
          source={source}
          logInfo={{
            category: 'C',
            action: 'Game_Non_Button',
            params: {
              id: data.ztId || '',
              type: 'zt',
              source,
            },
            bizInfo: data.bizInfo,
          }}
        />
        <div>
          {data.apps.slice(0, 5).map((app, index) => {
            let id = app.softID || '';
            if (app.androidType === '1') {
              id = app.packageName;
            }

            return (
              <GameLink
                key={index}
                info={{
                  targetType: '1',
                  appInfo: app,
                }}
                source={source}
                logInfo={{
                  category: 'C',
                  action: 'Game_Non_Button',
                  params: {
                    id,
                    type: 'soft',
                    source,
                  },
                  bizInfo: app.bizInfo,
                }}
              >
                <Icon className="icon" app={app} />
                <h1 title={app.softName}>{app.softName}</h1>
                <Button soft={app} className="action btn" logInfo={{ source }} />
              </GameLink>
            );
          })}
        </div>
      </section>
    </div>
  );
};
